import { Linkedin, Twitter, Mail, Phone } from "lucide-react";
import amxLogo from "@/assets/amx-logo-light.svg";

const FooterAlt = () => {
  return (
    <footer className="py-16 px-4 bg-card border-t-4 border-foreground">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img src={amxLogo} alt="AMX Ventures" className="h-12 w-auto" />
          </div>

          {/* Tagline */}
          <div className="md:col-span-2">
            <p className="text-2xl font-black leading-tight mb-6">
              CAPITAL THAT COMES WITH CHANNELS
            </p>
            <div className="flex flex-col md:flex-row gap-4 md:gap-8">
              <div className="flex gap-6 text-sm font-bold uppercase tracking-wider mb-4 md:mb-0">
                <a href="/portfolio" className="text-foreground hover:text-accent transition-colors">
                  Portfolio
                </a>
                <a href="/#ecosystem" className="text-foreground hover:text-accent transition-colors">
                  Ecosystem
                </a>
              </div>
              <div className="flex flex-col md:flex-row gap-3 md:gap-6">
                <a 
                  href="mailto:arun@amx.ventures" 
                  className="flex items-center gap-2 text-sm font-bold text-foreground hover:text-accent transition-colors group"
                >
                  <Mail className="w-4 h-4 group-hover:scale-110 transition-transform" />
                  <span className="tracking-wide">arun@amx.ventures</span>
                </a>
                <a 
                  href="tel:+971501724417" 
                  className="flex items-center gap-2 text-sm font-bold text-foreground hover:text-accent transition-colors group"
                >
                  <Phone className="w-4 h-4 group-hover:scale-110 transition-transform" />
                  <span className="tracking-wide">+971 50 172 4417</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center gap-4">
            <div className="text-sm font-bold uppercase tracking-wider text-muted-foreground">
              © 2025 AMX Ventures
            </div>
            <a 
              href="/disclaimer" 
              className="text-sm font-bold uppercase tracking-wider text-muted-foreground hover:text-accent transition-colors"
            >
              Disclaimer
            </a>
          </div>

          <div className="flex gap-4">
            <a 
              href="https://www.linkedin.com/in/arunmohanadfolks/" 
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 border-2 border-foreground bg-card hover:bg-foreground hover:text-background flex items-center justify-center transition-all"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-5 h-5" />
            </a>
            <a 
              href="https://x.com/_arunmohan" 
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 border-2 border-foreground bg-card hover:bg-foreground hover:text-background flex items-center justify-center transition-all"
              aria-label="Twitter"
            >
              <Twitter className="w-5 h-5" />
            </a>
            <a 
              href="mailto:arun@amx.ventures" 
              className="w-12 h-12 border-2 border-foreground bg-card hover:bg-foreground hover:text-background flex items-center justify-center transition-all"
              aria-label="Email"
            >
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterAlt;
